import styled from 'styled-components';

export const MainSection = styled.section`
display: flex;
flex-direction: column;
gap: 20px;`